// extracted by mini-css-extract-plugin
export var customEmptyMessage = "EmptyMessage-module--customEmptyMessage--b0ceb";
export var lmsScrollbar = "EmptyMessage-module--lms-scrollbar--97535";
export var messageHeading = "EmptyMessage-module--messageHeading--36260";
export var messageSubText = "EmptyMessage-module--messageSubText--cece7";